class ExitIntentSurvey {
    /**
     * @param {Object} config
     * @param {string} config.typeformUrl - Vollständige Typeform URL
     * @param {number} config.suppressDays - Anzahl Tage, die das Popup nach Schließen unterdrückt wird
     * @param {string} [config.storageKey] - localStorage Key
     */
    constructor(config) {
        this.typeformUrl = config.typeformUrl;
        this.suppressDays = config.suppressDays || 5;
        this.storageKey = config.storageKey || "exit_intent_suppressed_until";
        this.hasShown = false;
        this.overlayId = "exit-intent-overlay";
        this.containerId = "exit-intent-typeform-container";
        this.typeformScriptUrl = "https://embed.typeform.com/embed.js";
    }

    init() {
        if (!this.typeformUrl) return;
        this.loadTypeformScript();
        this.registerExitIntent();
    }

    // ============= Public API =============

    registerExitIntent() {

        let lastY = window.innerHeight;
        document.addEventListener("mousemove", (event) => {
            lastY = event.clientY;
        });

        this.createOverlay();
        document.addEventListener("mouseout", (event) => {
            if (event.clientY <= 0 && lastY < 50) {
                if (this.hasShown) return;
                if (this.isSuppressed()) return;

                this.hasShown = true;
                const overlay = document.getElementById(this.overlayId);
                overlay.style.display = "flex";
            }
        });
    }

    // ============= Core Logic =============
    createOverlay() {
        if (document.getElementById(this.overlayId)) return;

        const overlay = this.createOverlayElement();
        const container = this.createContainerElement();
        const closeButton = this.createCloseButton();

        closeButton.addEventListener("click", () => this.closeOverlay());

        overlay.appendChild(container);
        overlay.appendChild(closeButton);
        document.body.appendChild(overlay);

        this.mountTypeform(container);
    }

    closeOverlay() {
        const overlay = document.getElementById(this.overlayId);
        if (overlay && overlay.parentNode) {
            overlay.parentNode.removeChild(overlay);
        }
        this.suppressForDays(this.suppressDays);
    }

    // ============= Typeform Integration =============

    loadTypeformScript() {
        if (document.querySelector(`script[src="${this.typeformScriptUrl}"]`)) return;

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = this.typeformScriptUrl;
        const firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode.insertBefore(script, firstScript);
    }

    mountTypeform(container) {
        const mount = () => {
            if (!window.typeformEmbed || !window.typeformEmbed.makeWidget) return;
            window.typeformEmbed.makeWidget(container, this.typeformUrl, {
                hideHeaders: true,
                hideFooter: true,
                opacity: 0,
                buttonText: "Weiter",
                // onSubmit: () => this.closeOverlay()
            });
        };

        if (window.typeformEmbed && window.typeformEmbed.makeWidget) {
            mount();
            return;
        }

        let attempts = 0;
        const interval = setInterval(() => {
            attempts += 1;
            if (window.typeformEmbed && window.typeformEmbed.makeWidget) {
                clearInterval(interval);
                mount();
            } else if (attempts > 20) {
                clearInterval(interval);
            }
        }, 200);
    }

    // ============= DOM Helpers =============

    createOverlayElement() {
        const overlay = document.createElement("div");
        overlay.id = this.overlayId;
        Object.assign(overlay.style, {
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            backgroundColor: "#f7f7f7",
            zIndex: "99999",
            display: "none",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            boxSizing: "border-box",
            overflow: "hidden",
        });
        return overlay;
    }

    createContainerElement() {
        const container = document.createElement("div");
        container.id = this.containerId;
        Object.assign(container.style, {
            position: "relative",
            boxSizing: "border-box",
            width: "100vw",
            maxWidth: "90%",
            padding: "0 30px",
            height: "80vh",
            overflow: "hidden",
        });
        return container;
    }

    createCloseButton() {
        const button = document.createElement("button");
        button.innerHTML = "&times;";
        button.setAttribute("aria-label", "Fenster schließen");
        Object.assign(button.style, {
            position: "absolute",
            top: "12px",
            right: "16px",
            zIndex: "2",
            border: "none",
            background: "transparent",
            fontSize: "24px",
            cursor: "pointer",
            lineHeight: "1",
            color: "#444"
        });
        return button;
    }

    // ============= Storage / Suppression =============

    isSuppressed() {
        try {
            const stored = localStorage.getItem(this.storageKey);
            if (!stored) return false;
            const suppressUntil = parseInt(stored, 10);
            const now = Date.now();
            return now < suppressUntil;
        } catch {
            return false;
        }
    }

    suppressForDays(days) {
        try {
            const now = Date.now();
            const ms = days * 24 * 60 * 60 * 1000;
            const until = now + ms;
            localStorage.setItem(this.storageKey, String(until));
        } catch {
            // localStorage nicht verfügbar → einfach ignorieren
        }
    }
}
